module.exports = __webpack_public_path__ + "static/media/lua2012.f9b2f73c.jpg";